import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnswersService } from '../services/answers.service';
import { QuestionsService } from '../services/questions.service';

@Component({
  selector: 'app-confirmdelete',
  templateUrl: './confirmdelete.component.html',
  styleUrls: ['./confirmdelete.component.css']
})
export class ConfirmdeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmdeleteComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
  private questionService: QuestionsService, private answerService: AnswersService) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
}

delete(){
  if(this.data.type == "Question"){
    this.questionService.deletequestionbyID(this.data.question).subscribe(res=>{
     // console.log(res);
    });
  }
  else if(this.data.type == "Answer"){
    this.answerService.deleteanswerbyID(this.data.answer).subscribe(res=>{
     // console.log(res);
    });
  }
  else if(this.data.type == "Comment"){
    this.answerService.deletecommentbyID(this.data.comment).subscribe(res=>{
     // console.log(res);
    });
  }
  //console.log("Update");
  this.dialogRef.close();
}

}
